module.exports = __webpack_public_path__ + "img/logo.e4a4c78a.svg";